import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const fetchStats = async (queryParams) => {
  return await API.get(APIEndpoints.BRAND_STATS, null, queryParams);
  //   get: (url, option, query, successCallback, errorCallback)
};

const fetchBrandsLight = async (payload) => {
  return await API.get(APIEndpoints.CENTRAL_ONBOARDING.CLIENTS, payload);
  //   get: (url, option, query, successCallback, errorCallback)
};

export const brandAPI = {
  fetchStats,
  fetchBrandsLight,
};
